<template>
  <WsDialog
    v-model="dialog"
    ref="WsDialog"
    fullscreen
    maxWidth="95%"
    :title="title"
    :showCardActions="false"
    :isCloseScrollTop="isCloseScrollTop"
  >
    <template v-slot:content>
      <splitpanes firstSplitter class="default-theme lv-split-panes">
        <pane size="50" class="lv-split-panes__pane-container">
          <div ref="leftPane" class="lv-split-panes__pane">
            <div class="text-h6 mb-2 font-weight-bold">待鑑別法條</div>
            <div v-if="isLoading.leftData && leftDataList.length === 0">
              <v-skeleton-loader
                v-for="i in 15"
                :key="i"
                type="list-item"
                class="mb-2"
              />
            </div>
            <v-expansion-panels v-if="leftDataList.length > 0" v-model="openedPanelIndex">
              <v-expansion-panel v-for="(item, itemIndex) in leftDataList" :key="itemIndex">
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    {{ item.no_text }}
                    <LvChip
                      small
                      name="更新"
                      color="#fff7d0"
                      class="ml-2"
                    />
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12">
                      <WsCompareTable
                        isUpdate
                        :fields="_compareFields"
                        :modelData="item"
                        :updateData="item.updateData"
                        :getValueFunction="getCompareDialogValueFunction"
                        @input="$_onInput(itemIndex,$event.fieldKey,$event.value)"
                        @input-item="$_onInput(itemIndex,$event.fieldKey,$event.value)"
                      />
                      <div class="d-flex flex-column  ml-8 mb-3">
                        <div
                          class="mb-1 lv-split-panes__item-title"
                        >結果</div>
                        <WsStateRadio
                          :items="showCheckFail ? items : items.filter(item => item.value === '1')"
                          :defaultValue="item.updateData.isPass"
                          :value="item.updateData.isPass"
                          @input="$_onInput(itemIndex,'isPass',$event)"
                        />
                      </div>
                      <div
                        v-if="item.updateData.isPass == '0'"
                        class="d-flex flex-column ml-8 mb-3"
                      >
                        <div
                          class="mb-1 lv-split-panes__item-title"
                        >不通過備註</div>
                        <WsStateTextarea
                          autoGrow
                          :value="item.updateData.isPassRemark"
                          :maxlength="1000"
                          @input="$_onInput(itemIndex,'isPassRemark',$event)"
                        />
                      </div>
                      <v-divider class="mb-2" />
                      <div class="d-flex justify-end">
                        <WsBtn
                          minWidth="100px"
                          color="primary"
                          :loading="isLoading.submitUpdate"
                          @click="$_onSubmit(item, itemIndex)"
                        >送出</WsBtn>
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-icon
              v-if="
                !isLoading.leftData &&
                leftDataList.length > 0 &&
                pagination.left.ingPage < pagination.left.lastPage
              "
              class="lv-split-panes__pane__icon bounce-down"
            >mdi-arrow-down-bold-circle-outline</v-icon>
            <div v-if="isLoading.leftData && leftDataList.length > 0">
              <v-skeleton-loader
                v-for="i in 5"
                :key="i"
                type="list-item"
                class="mb-2"
              />
            </div>
          </div>
        </pane>
        <pane size="50" class="lv-split-panes__pane-container">
          <div ref="rightPane" class="lv-split-panes__pane">
            <div class="text-h6 mb-2 font-weight-bold">全部法條</div>
            <div v-if="isLoading.rightData && rightDataList.length === 0">
              <v-skeleton-loader
                v-for="i in 15"
                :key="i"
                type="list-item"
                class="mb-2"
              />
            </div>
            <v-expansion-panels v-if="rightDataList.length > 0">
              <v-expansion-panel v-for="(item, itemIndex) in rightDataList" :key="itemIndex">
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    {{ item.no_text }}
                    <LvChip
                      v-if="item.showUpdateChip"
                      small
                      name="更新"
                      color="#fff7d0"
                      class="ml-2"
                    />
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-if="item.showUpdateChip">
                    <v-col cols="12">
                      <WsCompareTable
                        :fields="_compareFields"
                        :modelData="item"
                        :getValueFunction="getCompareDialogValueFunction"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col
                      v-for="([fieldKey,field],fieldIndex) in rightDisplayFields"
                      :key="fieldIndex"
                      :cols="12"
                      :sm="field.sm ? field.sm : 12"
                      :style="{'display': $_displayCheck(field,item) ? 'initial' : 'none'}"
                    >
                      <WsInfo
                        :type="field.type"
                        :label="field.label"
                        :fields="field.fields"
                        :textKey="field.textKey"
                        :relationPopup="field.relationPopup"
                        :modelName="field.modelName"
                        :displayLabel="field.displayLabel"
                        :getText="field.getText"
                        :items="field.items"
                        :displayCheck="field.displayCheck"
                        :value="$_CMS_getValueByFieldKey(fieldKey,item)"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div v-if="isLoading.rightData && rightDataList.length > 0">
              <v-skeleton-loader
                v-for="i in 5"
                :key="i"
                type="list-item"
                class="mb-2"
              />
            </div>
          </div>
        </pane>
      </splitpanes>
    </template>
  </WsDialog>
</template>

<script>
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import S_idtf from '@/services/api/v1/idtf';
import Spare_idtf from "@/spare/idtf";

export default {
  components: { Splitpanes, Pane },
  props: {
    title: {
      type: String,
      default: '分頁檢視',
    },
    isCloseScrollTop: {
      type: Boolean,
      default: false,
    },
    leftFetchUrl: {
      type: String,
      default: '/article_version',
    },
    leftFetchParams: {
      type: Object,
    },
    rightFetchUrl: {
      type: String,
      default: '/article_version',
    },
    rightFetchParams: {
      type: Object,
    },
    setSplitPaneData: {
      type: Function,
    },
    rightDisplayFields: {
      type: Array,
    },
    getCompareDialogValueFunction: {
      type: Object,
    },
    idtfAssignmentId: {
      type: Number,
    },
    stage: {
      type: String,
    },
    showCheckFail: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
      leftDataList: [],
      rightDataList: [],
      isLoading: {
        leftData: false,
        rightData: false,
        submitUpdate: false,
      },
      pagination: {
        left: {
          ingPage: 1,
          lastPage: 1,
        },
        right: {
          ingPage: 1,
          lastPage: 1,
        },
      },
      updateData: {},
      openedPanelIndex: null,
      items: [
        {
          text: '通過',
          value: "1",
        },
        {
          text: '不通過',
          value: "0",
        },
      ],
      isEdited: false,
    };
  },
  computed: {
    _compareFields() {
      return Object.fromEntries(this.rightDisplayFields);
    },
  },
  watch: {
    async dialog(newVal) {
      if (newVal) {
        this.$_setScroll();
        await this.$_fetchLeftData();
        await this.$_fetchRightData();
      } else {
        if (this.isEdited) this.$emit('close');
        this.$_resetData();
        this.$_removeScroll();
      }
    },
    openedPanelIndex(newVal) {
      if (!newVal && newVal !== 0) return;
      this.$_CMS_updateDataSetFromFields(
        this,
        this.leftDataList[newVal].updateData,
        this._compareFields,
        this.leftDataList[newVal],
      );
      this.$set(this.leftDataList[newVal].updateData, 'isPass', this.leftDataList[newVal].isPass);
      this.$set(this.leftDataList[newVal].updateData, 'isPassRemark', this.leftDataList[newVal].isPassRemark);
    }
  },
  methods: {
    close() {
      this.dialog = false;
    },
    open() {
      this.dialog = true;
    },
    $_resetData() {
      this.leftDataList = [];
      this.rightDataList = [];
      this.pagination.left.ingPage = 1;
      this.pagination.right.ingPage = 1;
      this.pagination.left.lastPage = 1;
      this.pagination.right.lastPage = 1;
    },
    async $_fetchLeftData() {
      if (!this.leftFetchUrl || this.isLoading.leftData || this.pagination.left.ingPage > this.pagination.left.lastPage) return;
      try {
        this.isLoading.leftData = true;
        const res = await this.$axios.get(this.leftFetchUrl, {
          params: {
            ...this.leftFetchParams,
            page: this.pagination.left.ingPage,
          },
        });
        const { data, meta } = res.data;
        const newDataList = this.setSplitPaneData ? this.setSplitPaneData(data) : data;
        this.leftDataList = [...this.leftDataList, ...newDataList];
        this.pagination.left.lastPage = meta.last_page;
        this.pagination.left.ingPage = meta.current_page;
      } catch (error) {
        alert(error)
      } finally {
        this.isLoading.leftData = false;
      }
    },
    async $_fetchRightData() {
      if (!this.rightFetchUrl || this.isLoading.rightData || this.pagination.right.ingPage > this.pagination.right.lastPage) return;
      try {
        this.isLoading.rightData = true;
        const res = await this.$axios.get(this.rightFetchUrl, {
          params: {
            ...this.rightFetchParams,
            page: this.pagination.right.ingPage,
          },
        });
        const { data, meta } = res.data;
        const newDataList = this.setSplitPaneData ? this.setSplitPaneData(data) : data;
        this.rightDataList = [...this.rightDataList, ...newDataList];
        this.pagination.right.lastPage = meta.last_page;
        this.pagination.right.ingPage = meta.current_page;
      } catch (error) {
        alert(error)
      } finally {
        this.isLoading.rightData = false;
      }
    },
    $_displayCheck(field,originData) {
      const displayCheck = field.displayCheck;
      if (displayCheck) {
        return displayCheck(originData);
      } else return true;
    },
    $_onInput(itemIndex, fieldKey, $event) {
      this.$set(this.leftDataList[itemIndex].updateData, fieldKey, $event);
      if (fieldKey === 'effects' || fieldKey === 'll_comment' || fieldKey === 'isPass' || fieldKey === 'isPassRemark') {
        this.$set(this.leftDataList[itemIndex], fieldKey, $event);
      }
    },
    async $_onSubmit(item, itemIndex) {
      this.isLoading.submitUpdate = true;
      try {
        this.$_formatDataList(item, itemIndex);
        const submitData = this.$_setSubmitData(item);
        await S_idtf.updateIdtfItem(item.act_idtf_assignment_item.id, submitData);
        this.openedPanelIndex = null;
        this.isEdited = true;
      } catch (error) {
        alert(error)
      } finally {
        this.isLoading.submitUpdate = false;
      }
    },
    $_setSubmitData(item) {
      const { effects, ll_comment, isPass, isPassRemark } = item.updateData;
      const locale = this.$store.state.locale.selectingLocale;
      const remarkKeyList = Spare_idtf.remarkKeyList;
      return {
        act_idtf_assignment: this.idtfAssignmentId,
        effects,
        locales: {[locale]: {ll_comment}},
        [remarkKeyList[this.stage]]: isPass === '1' ? null : isPassRemark,
        [this.stage]: isPass,
      };
    },
    $_formatDataList(item, itemIndex) {
      const { isPass, isPassRemark } = item.updateData;
      if (isPass === '1' && isPassRemark !== null) {
        this.$set(this.leftDataList[itemIndex], 'isPassRemark', null);
        this.$set(this.leftDataList[itemIndex].updateData, 'isPassRemark', null);
      }
    },
    $_leftScrollHandle(e) {
      const scrollElm = e.target;
      if (
        scrollElm.scrollTop + scrollElm.clientHeight >=
        scrollElm.scrollHeight - 100
      ) {
        this.pagination.left.ingPage++;
        this.$_fetchLeftData();
      }
    },
    $_rightScrollHandle(e) {
      const scrollElm = e.target;
      if (
        scrollElm.scrollTop + scrollElm.clientHeight >=
        scrollElm.scrollHeight - 100
      ) {
        this.pagination.right.ingPage++;
        this.$_fetchRightData();
      }
    },
    $_setScroll() {
      this.$nextTick(() => {
        const leftScrollElm = this.$refs.leftPane;
        const rightScrollElm = this.$refs.rightPane;
        if (leftScrollElm) {
          leftScrollElm.addEventListener('wheel', this.$_leftScrollHandle);
        }
        if (rightScrollElm) {
          rightScrollElm.addEventListener('wheel', this.$_rightScrollHandle);
        }
      });
    },
    $_removeScroll() {
      const leftScrollElm = this.$refs.leftPane;
      const rightScrollElm = this.$refs.rightPane;
      if (leftScrollElm) {
        leftScrollElm.removeEventListener('wheel', this.$_leftScrollHandle);
      }
      if (rightScrollElm) {
        rightScrollElm.removeEventListener('wheel', this.$_rightScrollHandle);
      }
    }
  },
};
</script>

<style lang="scss">
  @import "../assets/scss/lv-split-panes.scss";
</style>